import { Component } from '@angular/core';

@Component({
  selector: 'app-no-role-navbar',
  templateUrl: './no-role-navbar.component.html',
  styleUrl: './no-role-navbar.component.scss',
  standalone: false,
})
export class NoRoleNavbarComponent {}
